export default {"src":"/_next/static/media/sar-bg.c370b93e.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};